import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { BookOpen, Search } from "lucide-react";
import { api } from "@/lib/api";
import { PageLoader, PageHeader } from "@/components/common";

export default function Rules() {
  const [search, setSearch] = useState("");
  const { data: conditions, isLoading } = useQuery({
    queryKey: ["conditions"],
    queryFn: async () => (await api.get("/conditions")).data,
  });

  const filtered = (conditions || []).filter((c) => c.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <PageHeader title="Rules Database" subtitle="SRD conditions and quick references" icon={BookOpen} />
      <div className="relative mb-6 max-w-md">
        <Search size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-zinc-500" />
        <input data-testid="rules-search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search conditions…" className="input-dark w-full rounded-xl pl-11 pr-4 py-2.5 text-sm" />
      </div>
      {isLoading ? <PageLoader /> : (
        <div className="grid md:grid-cols-2 gap-3">
          {filtered.map((c) => (
            <div key={c.id} className="glass rounded-2xl p-5" data-testid={`condition-${c.id}`}>
              <h3 className="font-display text-lg text-rose-300 mb-1.5">{c.name}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{c.description}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
